<template>
  <div>
    <div style="display: none;">
      [{{imgPath}},{{imagePath}}]
      [{{imgUrl}},{{imageUrl}}]
      [{{dir}},{{dirUrl}}]
    </div>
    <!--{{fileList}}-->
    <!--{{listType}}-->
    <!--[{{imgUrl}}}]-->
    <!--<el-input v-model="imgPath" type="text" ref="imgPath" readonly>{{imgPath}}</el-input>-->
    <el-upload
      class="avatar-uploader"
      action="https://jsonplaceholder.typicode.com/posts/"
      ref="upload"
      :disabled="disabled"
      :list-type="listType"

      :file-list="fileList"
      :show-file-list="listType!='picture'"
      :accept="acceptCurrent"
      :on-remove="handleRemove"
      :on-success="handleAvatarSuccess"
      :http-request="uploadSectionFile"
      :before-upload="beforeAvatarUpload" style="margin-top: 12px">
      <!--:limit="filesCountLimitCurrent"-->
      <!--<img v-if="imgUrl&&(imgUrl.indexOf('jpg')!=-1||imgUrl.indexOf('png')!=-1||imgUrl.indexOf('gif')!=-1)" :src="imgUrl" class="avatar">-->
      <!--<video :src="imgUrl" v-else-if="imgUrl&&imgUrl.indexOf('mp4')!=-1" controls></video>-->
      <!--<i class="el-icon-plus avatar-uploader-icon"></i>-->
      <!--<el-button size="small" type="primary">点击上传</el-button>-->
      <!--<span>{{imageProcess}}</span>-->
      <el-button size="small" type="primary" v-if="!isPreviewImgCurrent">点击上传</el-button>

      <!--&&fileList.length<filesCountLimitCurrent-->
<!--{{imageUrl}}-->
      <img v-if="isPreviewImgCurrent&&listType=='picture'&&imgUrl" :src="imgUrl" class="avatar" >
      <i v-else-if="isPreviewImgCurrent&&listType=='picture'" class="el-icon-plus avatar-uploader-icon"></i>

      <i slot="default" class="el-icon-plus" v-if="isPreviewImgCurrent&&listType=='picture-card'"></i>

      <div slot="file" slot-scope="{file}">

        <!--[{{isPreviewImgCurrent}}]-->
        <span  v-if="isPreviewImgCurrent==false"><i class="el-icon-document" style=""></i>{{file.name}}</span>

        <img
          v-if="isPreviewImgCurrent&&listType=='picture-card'"
          class="el-upload-list__item-thumbnail"
          :src="file.url" alt=""
        >
        <span class="el-upload-list__item-actions" v-if="isPreviewImgCurrent&&listType=='picture-card'">

        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>

        <span v-if="!isPreviewImgCurrent&&listType=='document'">

          <span
            @click="handleRemove(file)"
          >
          <i class="el-icon-delete">删除</i>
        </span>
        </span>
      </div>
    </el-upload>
    <!--<img :src="imageUrl" class="avatar" />-->
  </div>
</template>

<script>
//  import $ from 'jquery'
  import Vue from 'vue'
  import ossService from '../service/base/OssService.js'
  export default {
    name: 'ImgUploadOss',
    props: ['fieldName', 'imagePath', 'imageUrl'
      , 'dirUrl', 'limitSize', 'initObj'
      , 'isManyPic','filesCountLimit','accept','isPreviewImg','disabled','isMultiple'],
    data () {
      return {
        imgPath: this.imagePath,
        imgUrl: this.imageUrl,
        dir: this.dirUrl,
        oldDir:'formui',
        imageProcess: '',
        listType: 'picture-card',
        fileList: [],
        dialogVisible: false,
//        disabled: false,
        filesCountLimitCurrent:null,
        acceptCurrent:'',
        isPreviewImgCurrent:false,
      }
    },
    methods: {
      renderSize(value){
        if(null==value||value==''){
          return "0 Bytes";
        }
        let unitArr = ["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"];
        let index=0;
        let srcsize = parseFloat(value);
        index=Math.floor(Math.log(srcsize)/Math.log(1024));
        let size =srcsize/Math.pow(1024,index);
        size=size.toFixed(2);//保留的小数位数
        // alert(value)
        return size+unitArr[index];
      },
      // 上传文件之前校验
      beforeAvatarUpload (file) {

        if(this.limitSize){
          if(file.size>this.limitSize){
            let sizeLimitStr=(this.limitSize/1024/1024)+'M';
            console.warn('超过限制!'+(this.limitSize/1024/1024)+'M')
            this.$message.error('上传失败，文件过大。限制'+this.renderSize(this.limitSize));
            return false
          }
        }

        if(this.listType!='picture'&& this.fileList.length>=this.filesCountLimitCurrent&&this.isMultiple==true){
            this.$message.error('超过上传数量限制：'+(this.filesCountLimitCurrent));
            return false
        }

        return true
      },

      postImg (sign, form) {
        // alert('postimg' + sign['host'])
        let that = this
        var tot;


          that.$http({
              method: 'post',
              url: sign['host'],
              data:form
          }).then(function (res) {
//          that.$http.post(sign['host'], form).then(res => {
//              console.log('ooooooooosssssssssssss'+res.data);
              if (res) {
                  var link = sign['host'] + '/' + sign['key']
                  let newimagePath = sign['key']
                  // that.ruleForm.coverUrl = link
                  let newimageUrl = link

//        that.$emit('uploadImg', newimagePath, newimageUrl, that.initObj)

                  that.imgPath=newimagePath
                  that.imgUrl=newimageUrl
//            alert(that.listType)
                  if(that.listType=='picture'||that.isMultiple==false){
                      that.fileList=[]

                  }
                  that.fileList.push({name:newimagePath,url:newimageUrl,size:tot})
                  that.emitImg()
              }
          })


      },

      // 上传阿里云
      uploadSectionFile(param) {

        console.log("========uploadSectionFile=======")


        let that = this

        that.filelists = []
        that.filelists.push(param.file)

        console.log(that.filelists)


        this.dir=this.oldDir
        if(this.dirUrl){
          this.dir = this.dirUrl
        }

        this.imgUrl=''
        that.imageProcess=''

        ossService.ostObjectPolicy(this,{
//        'dir': window.UEDITOR_CONFIG.OSSDIR,
          'dir': this.dir,
          'srcname': param.file.name
        },function (resp) {
          var sign = resp;
          var form = new FormData();
          // var object_name = "" + window.UEDITOR_CONFIG.OSSDIR + "";
// 添加签名信息
          form.append('OSSAccessKeyId', sign['accessid']);
          form.append('policy', sign['policy']);
          form.append('Signature', sign['signature']);
          form.append('key', sign['key']);
// 添加文件
          form.append('file', param.file)
          // alert(1);

          that.postImg(sign, form)
        })

      },

      // 上传成功回调
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw)
        console.log("========handleAvatarSuccess=======")
      },

      handleRemove(file, fileList) {
        console.log(file);
        console.log(fileList);
        console.log(this.fileList.length);
//        console.log(this.fileList[0].name+'____'+file.name);
        for(let i=0;i<this.fileList.length;i++){
          if(this.fileList[i].name==file.name){
            this.fileList.splice(i,1);
          }
        }
        this.emitImg()
      },

      // 清除文件
      clearImgFiles() {
        this.imgPath = ''
        this.imgUrl = ''
        this.imageProcess = ''
        this.$refs.upload.clearFiles()
      },
      emitImg(){
        let that=this
//          that.$emit('uploadImg', newimagePath, newimageUrl, that.initObj)
        let arr=[]
        let arrUrl=[]
//          alert(this.fileList.length)


//          alert(2)
//          alert(arr.toString())
//         如果多图返回列表
        if(this.filesCountLimit>1){
//            if(this.listType=='picture'){
//                this.fileList=[]
//            }
          if(this.fileList&&this.fileList.length>0){
//              alert(this.fileList[0].name)
            for(let i=0;i<this.fileList.length;i++){
              arr.push(this.fileList[i].name)
              arrUrl.push(this.fileList[i].url)


            }
          }
        }

//        alert(this.fileList.length+'  '+arrUrl.length)
        if(this.filesCountLimit===1){
          if(this.fileList&&this.fileList.length===1){
            // console.log('------------------------------------------------')
            // console.log(this.fileList[0])
            //  alert(this.fileList[0].fileSize)
            for(let i=0;i<this.fileList.length;i++){
              arr.push(this.fileList[i].name)
              arrUrl.push(this.fileList[i].url)
            }
            //设置视频音频长度
          //
            if(this.fileList[0].name.indexOf('.mp3')!=-1||this.fileList[0].name.indexOf('.mp4')!=-1){
            var upAudio=new Audio()
            upAudio.src=this.fileList[0].url;

            upAudio.oncanplay=function(){
              let duration= parseInt(upAudio.duration*1000)
              that.$emit('setFieldValue', that.fieldName+'Duration',duration)
              // alert(duration)
            }

          }
            //

            that.$emit('setFieldValue', this.fieldName+'Size',this.fileList[0].size)

          }
        }


//alert(arrUrl)

        this.$emit('setFieldValue', this.fieldName,arr.toString())
        this.$emit('setFieldValue', this.fieldName+'Url',arrUrl.toString())
      }

    },
    updated () {
      // console.log(this)

      if (this.imagePath) {
        this.imgPath = this.imagePath
      }
      if (this.imageUrl) {
        this.imgUrl = this.imageUrl
      }
      if (this.dirUrl) {
        this.dir = this.dirUrl
      }

      if(this.imagePath){
//        for(let i=0;i<this.imagePath.length;i++){
//        alert(1)
//            this.fileList=this.imagePath
//        alert(2)
//        }

      }

      console.log('----------updated-0-----------')

      console.log('=======相对路径========')

      console.log('--> this.imagePath : '+this.imagePath )
      console.log('--> this.imgPath: '+this.imgPath)


      console.log('=======网络路径========')
      console.log('--> this.imageUrl :'+this.imageUrl )
      console.log('--> this.imgUrl : '+this.imgUrl )



      console.log('----------updated-1-----------')
    },
    mounted () {
      console.log(this.imagePath + ' ' + this.imgPath)
      if(this.filesCountLimit && this.filesCountLimit >1){
        this.listType = 'picture-card'
      }else{
          this.listType = 'picture'
      }
//alert(  this.isManyPic)
      console.log('----------mounted-oss-----------')
      if(this.filesCountLimit){
        this.filesCountLimitCurrent=this.filesCountLimit
      }
      if(this.accept){
        this.acceptCurrent=this.accept
      }
      if(this.isPreviewImg===true||this.isPreviewImg===false){
        this.isPreviewImgCurrent=this.isPreviewImg
      }
      if(this.isPreviewImgCurrent===false){
        this.listType='document'
      }

      if(this.listType=='picture'){
          this.filesCountLimitCurrent=null
      }



      if(this.imagePath){
          let imgPath=this.imagePath.split(',')
          let imgUrl=this.imageUrl.split(',')

          for(let i=0;i<imgPath.length;i++){
//              alert(imgUrl)
              this.fileList.push({name:imgPath[i],url:imgUrl[i],size:0})
          }

      }
//        that.fileList.push({name:newimagePath,url:newimageUrl,size:tot})
//      alert(this.imagePath)
    },
    destroyed () {
      // this.editor.destroy();
    }
  }
</script>

<style>
  /*.avatar-uploader .el-upload {*/
    /*border: 1px dashed #d9d9d9;*/
    /*border-radius: 6px;*/
    /*cursor: pointer;*/
    /*position: relative;*/
    /*overflow: hidden;*/
  /*}*/
  /*.avatar-uploader .el-upload:hover {*/
    /*border-color: #409EFF;*/
  /*}*/
  /*.avatar-uploader-icon {*/
  /*font-size: 28px;*/
  /*color: #8c939d;*/
  /*width: 178px;*/
  /*height: 178px;*/
  /*line-height: 178px;*/
  /*text-align: center;*/
  /*}*/
  /*.avatar {*/
    /*width: 178px;*/
    /*height: 178px;*/
    /*display: block;*/
  /*}*/
  /*ul.el-upload-list{display: block;width: 100%;}*/
  /*.el-upload-list__item{display: inline-block;}*/
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .avatar-uploader .el-upload.el-upload--document{border: none;}
</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/widget/FormUiFileUpload.vue